<template>
  <v-container class="fill-height addadvertiser" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="12">
        <v-card class="elevation-12">
          <v-toolbar dark flat>
            <v-toolbar-title>Add New Ad. </v-toolbar-title>
              <div v-if="inbank" class="errorshow">You have no sufficient amount.</div>
          </v-toolbar>
          <v-form @submit.prevent="validate" ref="form" lazy-validation>
            <v-card-text>
                <v-row>
                <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0">
                 <div><strong><span class="require">*</span>Title</strong></div>
                </v-col>
                 <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0">
                  <v-text-field v-model="adtitle"  :rules="adtitleRules" class="padding-top-0 padding-bottom-0" label=""></v-text-field>
                </v-col>
              </v-row> 
               <v-row>
                <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0">
                 <div><strong><span class="require">*</span>Select App.</strong></div>
                </v-col>
                  <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0">
                  <v-select v-model="adapp" :rules="adappRules" v-on:change="getzonelist($event)" :items="websitelist" item-text="publisherName" item-value="publisherId" label="" class="padding-top-0 padding-bottom-0" ></v-select>
                </v-col>
              </v-row> 
                <v-row>
                <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0">
                 <div><strong><span class="require">*</span>Select Ad. Position</strong></div>
                </v-col>
                  <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0">
                  <v-select v-model="adposition" :rules="adpositionRules"  :items="adpositions"  label="" class="padding-top-0 padding-bottom-0" ></v-select>
                </v-col>
              </v-row>
               <v-row> 
                <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0">
                 <div><strong><span class="require">*</span>Select Ad. Zone</strong></div>
                </v-col>
                  <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0">
                  <v-select v-model="adzone" :rules="adzoneRules" :items="websitezonelist" item-text="zoneName" item-value="zoneId"  label="" class="padding-top-0 padding-bottom-0" ></v-select>
                </v-col>
              </v-row>
                <v-row>
                <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0">
                 <div><strong><span class="require">*</span>Ad Placement</strong></div>
                </v-col> 
                  <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0">
                  <v-select v-model="adplacement" :rules="adplacementRules" :items="items" label="" class="padding-top-0 padding-bottom-0" ></v-select>
                </v-col>
              </v-row> 
               <v-row>
                <v-col cols="6" sm="6" md="6" class="padding-top-0 padding-bottom-0">
                <v-menu ref="from_date"  v-model="from_date"  :close-on-content-click="false"
                    :return-value.sync="from_date" transition="scale-transition"  offset-y  min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field  v-model="fromdate"  label="Ad. Start Date"
                        prepend-icon="mdi-calendar"   readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker  v-model="fromdate"  no-title  scrollable>
                      <v-spacer></v-spacer>
                      <v-btn    text  color="primary"  @click="fromdate = false">
                        Cancel    </v-btn>
                      <v-btn  text   color="primary" @click="$refs.from_date.save(from_date)" >OK</v-btn>
                    </v-date-picker>
                 </v-menu>
                 </v-col>
                  <v-col cols="6" sm="6" md="6" class="padding-top-0 padding-bottom-0">
                <v-menu ref="to_date"  v-model="to_date"  :close-on-content-click="false"
                    :return-value.sync="to_date" transition="scale-transition"  offset-y  min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field            v-model="todate"            label="Ad. End Date"
                        prepend-icon="mdi-calendar"   readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker  v-model="todate"  no-title  scrollable>
                      <v-spacer></v-spacer>
                      <v-btn    text  color="primary"  @click="todate = false">
                        Cancel    </v-btn>
                      <v-btn  text   color="primary" @click="$refs.to_date.save(to_date)" >OK</v-btn>
                    </v-date-picker>
                 </v-menu>
                 </v-col>
              </v-row>   
              <v-row>
                <v-col class="padding-top-0 padding-bottom-0">
                    <v-container class="padding-top-0 padding-bottom-0" fluid>
                       <v-radio-group   v-model="adtype"   row >
                        <template v-slot:label>
                        <div><strong>Ad Type</strong></div>
                        </template>
                         <input type="radio" class="radiocls" id="Image" value="web" name="adtype"  @click="getadtype($event)" v-model="adtype">
                          <label  class="radiolabelcls" for="Image">Image</label>
                          <input class="radiocls" type="radio" id="Html" value="html" name="adtype" @click="getadtype($event)" v-model="adtype">
                          <label  class="radiolabelcls" for="Html">Html</label>
                        </v-radio-group>
                    </v-container>
                </v-col>
              </v-row> 
               <v-row v-if="adtype =='web' ">
                <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0">
                 <div><strong><span class="require">*</span>Image</strong></div>
                </v-col>
                 <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0">
                   <!--<v-file-input    accept="image/*" class="padding-top-0 padding-bottom-0"   label="File input"  ></v-file-input> -->
                   <v-row>
                      <v-col cols="3" sm="3" md="3" class="padding-top-0 padding-bottom-0">
                   <v-btn  color="blue-grey" class="ma-2 white--text" @click="$refs.files.click()">
                                Upload<v-icon  right dark>mdi-cloud-upload</v-icon>
                              </v-btn>
                   </v-col>
                   <v-col cols="4" sm="4" md="4" class="padding-top-0 padding-bottom-0">
                        <v-avatar size="80px">
                     <!-- <img alt="Banner Image" :src="notimageimage" v-if="image === baseURL+'storage/1.1' || image === baseURL+'storage/.1'">
                       -->
                      <img alt="Banner Image" :src="image" v-if="image" >
                    </v-avatar>
                     </v-col>
                    <v-col cols="4" sm="4" md="4" >
                      <template v-if="image">
                                <div class="text-center">
                                  <v-dialog     v-model="dialog"  width="1000"                    height="750"
                                  >
                            <template   v-slot:activator="{ on, attrs }">
                        <v-btn color="blue lighten-2" dark   v-bind="attrs" v-on="on"                                      >
                                        Preview <v-icon  right dark>mdi-eye</v-icon>
                                      </v-btn>
                                    </template>

                                    <v-card>
                                      <v-card-title class="text-h5 grey lighten-2">
                                       Preview
                                      </v-card-title>
                                      <v-card-text>
                                          <!---- Start Preview ---->
                                              <v-row align="center" justify="center">
                                              <v-col cols="12" sm="12" md="12">
                                              <div class="row justify-content-center border py-5">
                                                <table width="95%" style="border:1px solid #b3d4fc;">
                                                  <tr>
                                                    <td colspan="3">
                                                        <div class="header-content">
                                                          <div class="col-12">
                                                             <img width="100%"  :src="headersection" >
                                                          </div>
                                                        </div>  
                                                      </td>  
                                                  </tr>
                                                  <tr>
                                                    <td width="30%">
                                                      
                                                      <div class="left-content">
                                                           <div class="col-lg-12 col-md-12">
                                                          <img  width="100%" :src="leftsection" >
                                                           </div>
                                                           <div class="col-lg-12 text-center col-md-12">
                                                             <h3> Ad. Here </h3>
                                                           </div>
                                                             <div class="col-lg-12 col-md-12">
                                    <draggable class="draggable-list"   @move="detectMove" group="my-group">
                                                              <img class="list-item"  alt="Avatar" :src="logo" >
                                                            </draggable>
                                                            </div>
                                                      </div>   
                                                    </td>
                                                    <td width="40%">
                                                      <div class="col-lg-12 col-md-12">
                                                          <img  width="100%" :src="middlesection" >
                                                           </div>
                                                    </td>
                                                    <td width="30%">
                                                         <div class="col-lg-12 col-md-12">
                                                          <img  width="100%" :src="rightsection" >
                                                           </div>
                                                            <div class="col-lg-12 text-center col-md-12">
                                                             <h3> Ad. Here </h3>
                                                           </div>
                                                             <div class="col-lg-12 col-md-12">
       <draggable class="draggable-list"  @move="detectMove" group="my-group">
                                                            </draggable>
                                                      </div> 
                                                      </td>  
                                                  </tr>  
                                                  
                                              </table>   
                                              </div>
                                              </v-col>
                                          </v-row>
                                              <!---- End Preview ---->
                                      </v-card-text>
                                      <v-divider></v-divider>
                                     <v-card-actions class="justify-end">
                                        <v-btn
                                          text
                                          @click="dialog.value = false"
                                        >Close</v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>
                                </div>
                              </template>
                    </v-col>  

                  
                  
                   </v-row>
                  <input type="file" style="display: none" id="files"  ref="files"  v-on:change="handleFilesUpload()"/>
                </v-col>
                 <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0">
                   <h5>You can upload a JPG,PNG or WEBP </h5>
                    <h5>Recommended Dimesion 400 x 304 (Horizantal Image) or 400 x 608 (Vertical Image)</h5>
                 </v-col>
               </v-row>
               <v-row v-if="adtype =='html'">
                  <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0">
                 <div><strong>Append and prepend settings</strong></div>
                </v-col>
                 <v-col col="12">
                   <template>
                      <v-container fluid>
                        <v-row>
                          <v-col   cols="12"   md="12">
                            <v-textarea v-model="htmlprepend" label="Always prepend the following HTML code to this banner" ></v-textarea>
                          </v-col>
                          <v-col  cols="12"  md="12">
                            <v-textarea  v-model="htmlappend"  label="Always append the following HTML code to this banner"></v-textarea>
                          </v-col>      
                        </v-row>
                      </v-container>
                    </template>
                 </v-col>  
               </v-row>  

                 <v-row>
                <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0">
                 <div><strong><span class="require">*</span> Destination  Url</strong></div>
                </v-col>
                 <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0">
                  <v-text-field v-model="destinationurl"  :rules="destinationurlRules" class="padding-top-0 padding-bottom-0" label="http://domain.com"></v-text-field>
                </v-col>
               </v-row>
                 <v-row>
                <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0">
                 <div><strong>Image Tooltip Text</strong></div>
                </v-col>
                 <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0">
                  <v-text-field v-model="imgtooltiptext" class="padding-top-0 padding-bottom-0" label="Text"></v-text-field>
                </v-col> 
               </v-row>
            </v-card-text>
            <v-card-actions >
                <v-row>
                <v-col cols="6" sm="6" md="6" class="padding-top-0 padding-bottom-0 text-right">
                 <v-btn type="submit" color="primary">Continue</v-btn>
                </v-col>
                <v-col cols="6" sm="6" md="6" class="padding-top-0 padding-bottom-0 text-left">
                  <v-btn type="submit" color="warning">Preview</v-btn>
                </v-col>
               </v-row>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>

      

    </v-row>
   
  </v-container>
</template>

<script>
//import { mapState } from 'vuex'
import draggable from "vuedraggable";
var adplacementarr = [{text: 'Feed Ad Block (5 USD per 1000 views)', value: '5'}, {text: 'Feed Ad Block (10 USD per 2000 views)', value: '10'}] ;
//adplacementarr[5] = "Feed Ad Block (5 USD per 1000 views)";
//adplacementarr[10] = "Feed Ad Block (10 USD per 2000 views)";

export default {
  name: "Register",
  components: {
    draggable,
  },
  data() {
    return {
      dialog: false,
      bannersection: "left",
      bannerrightsection:"right",
      headersection : require("@/assets/headersection.png"),
      leftsection : require("@/assets/leftsection.png"),
      middlesection:  require("@/assets/middlesection.png"),
      rightsection :  require("@/assets/rightsection.png"),
      logo: require("@/assets/logo.png"),
      list1: [{ name: require("@/assets/logo.png") }],
      list2: [],
      items: adplacementarr,
      imgtooltiptext : "",
      destinationurl: "",
      adtype: "web",
      websitelist : [],
      websitezonelist : [],
      adpositions : ['Left','Right','Top','Bottom'],
     // to_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    //  from_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      to_date: "",
      from_date: "",
      fromdate: "2022-03-09",
      todate: "2022-03-30",
      adapp:1,
      adposition : "",
      adzone:[] ,
      file: '',
      files:[],
      image:"",
      adplacement :"",
      htmlprepend :"",
      htmlappend : "",
      adtitle:"",
      adappRules: [v => !!v || 'Select Ad. App.',
                   //   v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                    ],
      adpositionRules: [v => !!v || 'Select Ad. Position',],
      adplacementRules: [v => !!v || 'Select Ad. Placement',],
      adzoneRules: [v => !!v || 'Select Ad. Zone',],     
      destinationurlRules: [v => !!v || 'Enter Destination Url',], 
      adtitleRules: [v => !!v || 'Banner Title',],     
      inbank: this.$store.state.showamount > 5 ? true : false
       
    };
  },
   mounted() {
    this.getAdserverWebsiteList();
     this.getDamanBalance();
  },
   computed:{
    // ...mapState({
    //   image:'bannerimage'
    // }),

          baseURL() {
              const url = process.env.VUE_APP_BASEAPI.slice(0, -4);
              return url;
            }
     },
  methods: {
     detectMove: function(evt){
       console.log(evt)
      },
      getDamanBalance() {
          this.$store.dispatch("retrieveDammnbankBalance").then(() => {
           });
      },  
        getInbankBalance() {
          this.$store.dispatch("retrieveInbankKelBalance").then(() => {
         });
      },
    validate() {
      if (this.$refs.form.validate()) {
        this.addbanner();
      }
    },
     getAdserverWebsiteList() {
      this.$store.dispatch("retrieveAdserverWebsitesList", {
        })
        .then(response => {
          this.websitelist = response;
          console.log(this.websitelist);
      })
        .catch(error => {
          // TODO: handle incorrect login
          console.log("Website List error");
          console.log(error);
        });
    },
    getzonelist(getwebsiteid)
    {
        //alert(getwebsiteid);
        this.$store.dispatch("retrieveWebsiteZoneList",{websiteid : getwebsiteid}, {
        })
        .then(response => {
          this.websitezonelist = response.data;
          console.log(this.websitezonelist);
      })
        .catch(error => {
          // TODO: handle incorrect login
          console.log("Website Zone List error");
          console.log(error);
        });
    },
     handleFilesUpload(){
        let uploadedFiles = this.$refs.files.files;
         
        for( var i = 0; i < uploadedFiles.length; i++ ){
          this.files.push( uploadedFiles[i] );
          console.log(URL.createObjectURL(uploadedFiles[i]));
        //  this.$store.state.bannerimage = URL.createObjectURL(uploadedFiles[i]);
           this.image = URL.createObjectURL(uploadedFiles[i]);
           this.logo = URL.createObjectURL(uploadedFiles[i]);
          
        }
      },
      addbanner() {

      let formData = new FormData();
        
        for( var i = 0; i < this.files.length; i++ ){
          let file = this.files[i];
          
          formData.append('aImage', file);
        }  
        // Display the key/value pairs
for (var pair of formData.entries()) {
    console.log(pair[0]+ ', ' + pair[1]); 
}
        formData.append('filename', "download2.png");
        formData.append('campaignId', 2);
        formData.append('bannerName', this.adtitle);             
        formData.append('storageType', this.adtype);
        formData.append('htmltemplate', "Html Content");
        formData.append('url', this.destinationurl);
        formData.append('alt', this.imgtooltiptext);
           
       //********  Not Adserver */    
       formData.append('adapp', this.adapp);
       formData.append('adposition', this.adposition);
       formData.append('adzone', this.adzone);
       formData.append('adplacement', this.adplacement);
       formData.append('fromdate', this.fromdate);
       formData.append('todate', this.todate);
       formData.append('htmlprepend', this.htmlprepend);
       formData.append('htmlappend', this.htmlappend);
     
      this.$store
        .dispatch("adserveraddbanner", formData)
        .then(response => {
       //   this.debitBalance(this.adplacement * 100);
          formData.append('bannerid', response.bannerId);
          formData.append('bannerimage', response.filename);
          this.adserverlinkbannerzone(this.adzone,response.bannerId);
          this.savequizstarbanner(formData);
        
         // console.log(response);
              })
        .catch(error => {
          // TODO: handle incorrect login
          console.log("Add Banner error");
          console.log(error);
        });
     
       
    },
     debitBalance(getamount) {

       var api_amount = getamount;
       var   api_currencytype = "currency";
       this.$store.dispatch("debitBalance",{
            amount:api_amount,
            type:api_currencytype,
            reason:"Banner Created",
           // gametype:game_type
          
          }).then(() => {
            //this.showinbankbalance = this.$store.getters.showamount;
            //this.showkelamount = this.$store.getters.showkelamount;

         });
     },
     savequizstarbanner(formData)
     {
         this.$store
        .dispatch("quizstaraddbanner", formData)
        .then(response => {
          console.log(response);
            this.$router.push({ name: "adlist" });
              })
        .catch(error => {
          // TODO: handle incorrect login
          console.log("Quizstar Add Banner error");
          console.log(error);
        });
     },
     adserverlinkbannerzone(zoneid,bannerid) {
       this.$store.dispatch("adserverlinkbannerzone",{
            zoneid:zoneid,
            bannerid:bannerid 
          }).then(() => {
            //this.showinbankbalance = this.$store.getters.showamount;
            //this.showkelamount = this.$store.getters.showkelamount;

         });
     },
     getadtype(getadtype)
     {
        console.log(getadtype);
     }
  }
};
</script>

<style scoped>
.row {
  margin-left: 0px;
}
#addadvertiser .v-card__subtitle, .v-card__text, .v-card__title {
    padding: 4px !important;}
.padding-top-0{padding-top: 0px !important;}
.padding-bottom-0{padding-bottom: 0px !important;}    
.require{color: red; font-size: 15px;}
.radiolabelcls{padding-left:10px !important;}
.radiocls{padding-left:10px !important;}
.radiolabelcls{padding-left: 10px !important;padding-right: 5px !important;margin-top: -3px;
}
.errorshow{color:red;font-size: 15px;margin:0 auto;}
.draggable-list {
  background: #eee;
  color: #fff;
  border: 1px solid;
  height: 100px;
}
.list-item {
  width:100%;
  height: 100%;
  position: relative;
}
.h5{background-color: hsl(240deg 19% 82%);font-size:18px;}
.header-content{width:100%;height: 71px;}
.left-content{height: 100%; }
.center-content{height: 100%;}
.right-content{height: 100%;}
.footer-content{height: 100%; border:1px solid #b3d4fc;}
</style>